import { List, Map } from 'immutable';
import UnitOnlineUsage from './UnitOnlineUsage';
import OnlineUsage from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, `${val}`]; // stringify
    case 'unitOnlineUsages':
      return [key, new Map(val.map((data) => {
        const unitOnlineUsage = UnitOnlineUsage.create(data);
        return [unitOnlineUsage.unitNo, unitOnlineUsage];
      }))];
    case 'selectedCourse':
      return [key, new List(val)];
    default:
      return [key, val];
  }
};
const create = (data) =>
  new OnlineUsage(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/OnlineUsage/create.js